<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="编辑地址" id="nav-bar" @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon size="20" name="phone-o" />
      </template>
    </van-nav-bar>

    <van-cell-group>
      <van-field v-model="addreForm.contacts" label="姓名" placeholder="请输入姓名" />
    </van-cell-group>

    <van-cell-group>
      <van-field v-model="addreForm.phone" label="手机号" placeholder="请输入手机号" />
    </van-cell-group>

    <van-field readonly clickable name="picker" :value="addreForm.region" label="省市区" placeholder="点击选择城市" @click="IsShow = true" />

    <van-field v-model="addreForm.address" rows="2" autosize label="详细信息" type="textarea" maxlength="50" placeholder="请输入详细信息" show-word-limit />

    <van-cell center title="默认">
      <template #right-icon>
        <van-switch v-model="addreForm.is_default" active-color="#ff5000" active-value="1" inactive-value="0" size="24" />
      </template>
    </van-cell>

    <van-popup v-model="IsShow" position="bottom">

      <van-area title="选择地址" @confirm="onConfirm" @cancel="IsShow = false" :value="addreForm.aid" :area-list="areaList" />
    </van-popup>

    <div class="foot-btn">
      <div class="btn btnl" v-if="isPage == 1" @click="addreClose">取消</div>
      <div class="btn btnl" v-if="isPage == 2" @click="addreDelete">删除</div>
      <div class="btn btnr" @click="add">保存地址</div>
    </div>
  </div>
</template>

<script>
let areaData = require("../../utils/area.js"); //根据需求改成你自己的路径
export default {
  name: "AdderssEdit",
  components: {},
  props: {},
  data() {
    return {
      id: this.$route.query.id || "",

      checked: 0,

      areaList: areaData.default,
      IsShow: false,

      isPage: this.$route.query.isPage || 1, //1新增 2编辑
      addreForm: {
        uid: Lockr.get("userId"), // uid
        address_id: undefined, // 修改时使用

        contacts: "", //联系人姓名
        phone: "", //联系人手机号码
        is_default: "0", //是否默认地址 1=是 0=否
        pid: "", //省
        cid: "", //市
        aid: "310101", //区
        region: "", //前置地址
        address: "", //详细地址
      },
    };
  },
  watch: {
    "addreForm.is_default"(b, n) {
      // console.log(b,n)
    },
  },
  created() {},
  mounted() {
    let _this = this;
    if (this.$route.query.isPage == 2) {
      this.addreForm = JSON.parse(this.$route.query.addsInfo);
      this.addreForm.address_id = this.$route.query.id;
      this.addreForm.is_default = JSON.parse(
        this.$route.query.addsInfo
      ).is_default.toString();
    }
  },
  methods: {
    onConfirm(value) {
      // console.log(value)
      // this.value = value;
      this.addreForm.region =
        value[0].name + "/" + value[1].name + "/" + value[2].name; //前置地址
      this.addreForm.pid = value[0].code; //省
      this.addreForm.cid = value[1].code; //市
      this.addreForm.aid = value[2].code; //区
      this.IsShow = false;
    },
    // 删除
    addreDelete() {
      let _this = this;
      let data = {
        
        uid: Lockr.get("userId"), // uid
        address_ids:_this.id, 
      }
      _this.$post("/api/user_address_del" , data,data ).then((res) => {
        //  console.log(res);
        if (res.data.code == 0) {
          _this.$toast({
            type: "success",
            message: "删除成功！",
            onClose: () => {
              //console.log('执行OnClose函数');
              _this.$router.go(-1);
            },
          });
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    addreClose() {
      let _this = this;
      _this.$router.go(-1);
    },
    add() {
      // console.log(this.addreForm)
      let _this = this;
      if (!_this.addreForm.contacts) {
        this.$toast.fail("收货人姓名不可为空！");
      } else if (!/^1[3456789]\d{9}$/.test(_this.addreForm.phone)) {
        this.$toast.fail("手机号错误！请重新填写");
      } else if (!_this.addreForm.region) {
        this.$toast.fail("请选择省市区！");
      } else if (!_this.addreForm.address) {
        this.$toast.fail("请填写详细地址！");
      }

      // 新增
      _this
        .$post("/api/user_address_save", _this.addreForm, _this.addreForm)
        .then((res) => {
          //  console.log(res);
          if (res.data.code == 0) {
            _this.$toast({
              type: "success",
              message: "保存成功！",
              onClose: () => {
                //console.log('执行OnClose函数');
                _this.$router.go(-1);
              },
            });
          } else {
            _this.$toast.fail(res.data.message);
          }
        });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.MakeCall(); //拨打电话
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 50px 0;
  text-align: left;

  .foot-btn {
    position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    height: 45px;
    background-color: #ffffff;
    border-top: 1px solid #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    width: 172px;
    height: 40px;
    /* background: #03A8C0; */
    opacity: 1;

    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btnl {
    background: #ff510093;
    border-radius: 20px 0px 0px 20px;
  }
  .btnr {
    background: #ff5000;
    border-radius: 0px 20px 20px 0px;
  }
  .btd {
    background-color: #e95970;
  }
}
</style>
